import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { useCustomTheme } from '@/hooks/useCustomTheme';

export const StyledSkeleton = () => {
  const { customBorderRadius, palette } = useCustomTheme();

  return (
    <Box paddingY={'3px'}>
      <Skeleton
        variant={'rect'}
        height={'32px'}
        style={{ borderRadius: customBorderRadius.paper, backgroundColor: palette.grey[50] }}
      />
    </Box>
  );
};
